<template>
    <ul class="sidebar-user-menu-list">
        <SidebarMenuItem 
            v-for="(menuItem, index) in filteredMenus" 
			:key="index" 
			:item="menuItem"
        />
    </ul>
</template>

<script>
import { mapState } from 'pinia';
import { useAuthStore } from '@/store/auth';
import { useAppStore } from '@/store/app';
import { defineAsyncComponent } from 'vue';
const SidebarMenuItem = defineAsyncComponent(() => import('./SidebarMenuItem.vue'));

export default {
    components: {
        SidebarMenuItem
    },
    computed: {
		...mapState(useAppStore, ['menus']),
        ...mapState(useAuthStore, ['user']),
        filteredMenus() {
            const items = this.menus?.main || []
            return items.filter((item) => {
                const url = (item?.url || '').toString().toLowerCase()
                const alias = (item?.alias || '').toString().toLowerCase()
                const onlyForPage = !!item?.only_for_page
                const isCmsItem = alias === 'cms' || /(^|\/)cms(\/|$|\?|#)/.test(url) || url.includes('user_pages/cms')
                if (onlyForPage || isCmsItem) {
                    return !!this.user?.is_page
                }
                return true
            })
        }
    }
};
</script>
